import { combineReducers } from 'redux';
import { createReducer, createSlice } from '@reduxjs/toolkit';
import workerSchedulePageActions from './workerSchedulePageActions';
import { compareWorkersCrewLeaderThenAlpha } from 'helpers/_helpers';

// Full Schedule
const initialState = {
  fullSchedule: {
    selectedDate: new Date(),
    sheets: [],
  },
  mySchedule: {
    selectedDate: new Date(),
    sheets: [],
  }
};

const sortWorkersIfAny = (workers) => (Array.isArray(workers) ? workers.slice().sort(compareWorkersCrewLeaderThenAlpha) : workers);

const fullSchedulePageReducer = createReducer(initialState.fullSchedule, {
  [workerSchedulePageActions.reset]: () => initialState.fullSchedule,
  [workerSchedulePageActions.setFullScheduleDate]: (state, { payload }) => ({ ...state, selectedDate: payload }),
  [workerSchedulePageActions.getFullScheduleSheets]: (state, { payload }) => ({ ...state, sheets: payload.map(s => ({ ...s, workers: sortWorkersIfAny(s.workers) })) }),
  [workerSchedulePageActions.addFullScheduleSheet]: (state, { payload }) => ({ ...state, sheets: [...state.sheets, { ...payload, workers: sortWorkersIfAny(payload.workers) }] }),
  [workerSchedulePageActions.putFullScheduleSheet]: (state, { payload }) => ({
    ...state,
    sheets: state.sheets.map(sheet => sheet._id === payload._id ? { ...payload, workers: sortWorkersIfAny(payload.workers) } : sheet),
  }),
  [workerSchedulePageActions.patchFullScheduleSheet]: (state, { payload }) => ({
    ...state,
    sheets: state.sheets.map(sheet => sheet._id === payload._id ? { ...sheet, ...payload, workers: sortWorkersIfAny(payload.workers ?? sheet.workers) } : sheet),
  }),
  [workerSchedulePageActions.deleteFullScheduleSheet]: (state, { payload }) => ({
    ...state,
    sheets: state.sheets.filter(sheet => sheet._id !== payload._id)
  }),
  [workerSchedulePageActions.patchFullScheduleSheetWorker]: (state, { payload }) => ({
    ...state,
    sheets: state.sheets.map(sheet => sheet._id === payload._id
        ? {
          ...sheet,
          workers: sortWorkersIfAny(sheet.workers.map(worker => worker._id === payload.worker._id ? ({ ...worker, ...payload.worker }) : worker))
        }
        : sheet
    )
  }),
  [workerSchedulePageActions.patchFullScheduleWorker]: (state, { payload }) => ({
    ...state,
    sheets: state.sheets.map((sheet) => ({
      ...sheet,
      workers: sortWorkersIfAny(sheet.workers.map(worker => worker._id === payload._id ? ({ ...worker, ...payload }) : worker)),
    }))
  }),
  [workerSchedulePageActions.patchFullScheduleEquipment]: (state, { payload }) => ({
    ...state,
    sheets: state.sheets.map((sheet) => ({
      ...sheet,
      equipment: sheet.equipment.map(equip => equip._id === payload._id ? ({ ...equip, ...payload }) : equip),
    }))
  }),
})

// My Schedule
const mySchedulePageReducer = createReducer(initialState.mySchedule, {
  [workerSchedulePageActions.reset]: () => initialState.mySchedule,
  [workerSchedulePageActions.setMyScheduleDate]: (state, { payload }) => ({ ...state, selectedDate: payload }),
  [workerSchedulePageActions.getMyScheduleSheets]: (state, { payload }) => ({ ...state, sheets: payload.map(s => ({ ...s, workers: sortWorkersIfAny(s.workers) })) }),
  [workerSchedulePageActions.addMyScheduleSheet]: (state, { payload }) => ({ ...state, sheets: [...state.sheets, { ...payload, workers: sortWorkersIfAny(payload.workers) }] }),
  [workerSchedulePageActions.putMyScheduleSheet]: (state, { payload }) => ({
    ...state,
    sheets: state.sheets.map(sheet => sheet._id === payload._id ? { ...payload, workers: sortWorkersIfAny(payload.workers) } : sheet),
  }),
  [workerSchedulePageActions.patchMyScheduleSheet]: (state, { payload }) => ({
    ...state,
    sheets: state.sheets.map(sheet => sheet._id === payload._id ? { ...sheet, ...payload, workers: sortWorkersIfAny(payload.workers ?? sheet.workers) } : sheet),
  }),
  [workerSchedulePageActions.deleteMyScheduleSheet]: (state, { payload }) => ({
    ...state,
    sheets: state.sheets.filter(sheet => sheet._id !== payload._id)
  }),
  [workerSchedulePageActions.patchMyScheduleSheetWorker]: (state, { payload }) => ({
    ...state,
    sheets: state.sheets.map(sheet => sheet._id === payload._id
        ? {
          ...sheet,
          workers: sortWorkersIfAny(sheet.workers.map(worker => worker._id === payload.worker._id ? ({ ...worker, ...payload.worker }) : worker))
        }
        : sheet
    )
  }),
  [workerSchedulePageActions.patchMyScheduleWorker]: (state, { payload }) => ({
    ...state,
    sheets: state.sheets.map((sheet) => ({
      ...sheet,
      workers: sortWorkersIfAny(sheet.workers.map(worker => worker._id === payload._id ? ({ ...worker, ...payload }) : worker)),
    }))
  }),
  [workerSchedulePageActions.patchMyScheduleEquipment]: (state, { payload }) => ({
    ...state,
    sheets: state.sheets.map((sheet) => ({
      ...sheet,
      equipment: sheet.equipment.map(equip => equip._id === payload._id ? ({ ...equip, ...payload }) : equip),
    }))
  }),
})

// Loading slice
const loadingSlice = createSlice({
  name: 'loading',
  initialState: false,
  reducers: {
    [workerSchedulePageActions.setLoading]: (state, { payload }) => payload,
  }
});

// SnackBar slice
const snackBarSlice = createSlice({
  name: 'snackbar',
  initialState: null,
  reducers: {
    [workerSchedulePageActions.setSnackbar]: (state, { payload }) => payload,
    [workerSchedulePageActions.closeSnackbar]: () => null,
  }
});

export default combineReducers({
  mySchedule: mySchedulePageReducer,
  fullSchedule: fullSchedulePageReducer,
  loading: loadingSlice.reducer,
  snackbar: snackBarSlice.reducer,
});
